import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { IonLoading, IonButton, IonList, IonText } from '@ionic/react';
import { InputField } from 'components/form';
import AppActions from 'redux/AppRedux';
import { AuthSelectors } from 'redux/AuthRedux';
import api_v2 from 'services/api_v2';
import { PaySelectors } from 'redux/PayRedux';
import schema from './schema';

const INITIAL_VALUES = {
  tableNumber: '',
};

function TableNumberForm({ venueId, onSubmit, setShowPaymentErrorAlert }) {
  const dispatch = useDispatch();
  const token = useSelector(AuthSelectors.selectToken);
  const cardId = useSelector(PaySelectors.selectCurrentMethod);

  const getCardPreAuthorization = async () => {
    try {
      const api = api_v2(token);
      await api.preauthorizeCard(cardId);
      return true;
    } catch (error) {
      setShowPaymentErrorAlert(true);
      return false;
    }
  };

  const handleSubmit = async (values, actions) => {
    try {
      const api = api_v2(token);
      const resp = await api.getTicketByTableNumber(
        venueId,
        values.tableNumber
      );
      const isCardPreAuthorization = await getCardPreAuthorization();

      if (isCardPreAuthorization && resp) {
        onSubmit(resp);
      } else if (isCardPreAuthorization && !resp) {
        dispatch(
          AppActions.setToast(
            'No open tabs found for this table number. Please order with your server.',
            'danger'
          )
        );
      }
    } catch (e) {
      if (e.httpCode === 404) {
        dispatch(
          AppActions.setToast(
            'No open tabs found for this table number. Please order with your server.',
            'danger'
          )
        );
      } else {
        dispatch(
          AppActions.setToast(
            e.message ||
              'There are no items added to your check yet. Please order with your server.',
            'danger'
          )
        );
      }
    }

    actions.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={{ ...INITIAL_VALUES }}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ isSubmitting }) => {
        return (
          <Form>
            <IonLoading isOpen={isSubmitting} message="Loading..." />
            <IonList>
              <div className="text-center mt-3x mb-3x">
                <IonText>
                  <h3 className="mx-2x mb-3x">
                    What table number are you seated at?
                  </h3>
                  <p>
                    Hint: Your server knows your table number if it's not
                    clearly marked.
                  </p>
                </IonText>
              </div>
              <Field
                component={InputField}
                name="tableNumber"
                label="Table Number *"
              />
              <div className="mb-5x mt-3x">
                <IonButton
                  color="secondary"
                  expand="block"
                  fill="solid"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Go to Tab
                </IonButton>
              </div>
            </IonList>
          </Form>
        );
      }}
    </Formik>
  );
}

TableNumberForm.propTypes = {
  venueId: PropTypes.string,
  onSubmit: PropTypes.func,
  setShowPaymentErrorAlert: PropTypes.func,
};

export default TableNumberForm;
